// storyboardApi.js - 负责调用后端API生成分镜图片

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

/**
 * 生成单张图片
 */
export async function generateImage(prompt, options = {}) {
  try {
    const response = await fetch(`${API_BASE_URL}/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        prompt,
        model: options.model || 'Tongyi-MAI/Z-Image-Turbo',
        width: options.width || 1024,
        height: options.height || 576,
      }),
    });

    if (!response.ok) {
      // 检查响应是否为 JSON
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const error = await response.json();
        throw new Error(error.error || error.detail || '生成图片失败');
      } else {
        // 如果不是 JSON，可能是 HTML 错误页面
        const text = await response.text();
        throw new Error(`服务器错误 (${response.status}): ${text.substring(0, 100)}`);
      }
    }

    // 确保响应是 JSON
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`服务器返回了非 JSON 响应: ${text.substring(0, 100)}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('生成图片API错误:', error);
    throw error;
  }
}

/**
 * 批量生成分镜图片
 * @param {Array} shots - 镜头数组，每个镜头包含 { id, desc, title }
 * @param {Object} options - 选项 { model, width, height }
 */
export async function generateStoryboard(shots, options = {}) {
  try {
    console.log('📡 调用批量生成API，镜头数量:', shots.length);
    
    const response = await fetch(`${API_BASE_URL}/generate-storyboard`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        shots: shots.map(shot => ({
          id: shot.id,
          desc: shot.desc || shot.prompt,
          title: shot.title,
        })),
        model: options.model || 'Tongyi-MAI/Z-Image-Turbo',
        width: options.width || 1024,
        height: options.height || 576,
      }),
    });

    if (!response.ok) {
      // 检查响应是否为 JSON
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const error = await response.json();
        throw new Error(error.error || error.detail || '批量生成失败');
      } else {
        // 如果不是 JSON，可能是 HTML 错误页面
        const text = await response.text();
        throw new Error(`服务器错误 (${response.status}): ${text.substring(0, 100)}`);
      }
    }

    // 确保响应是 JSON
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`服务器返回了非 JSON 响应: ${text.substring(0, 100)}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('批量生成API错误:', error);
    throw error;
  }
}

/**
 * 健康检查
 */
export async function ping() {
  try {
    const response = await fetch(`${API_BASE_URL}/ping`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('健康检查失败:', error);
    throw error;
  }
}